import { render, staticRenderFns } from "./BookServiceHeader.vue?vue&type=template&id=10a29794"
import script from "./BookServiceHeader.vue?vue&type=script&lang=js"
export * from "./BookServiceHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports